import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";

import { DatePipe } from '@angular/common';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material';


import { Espace } from '../../model/espace.model';
import { EspaceService } from '../../service/espace.service';
import { Client } from '../../model/client.model';

import { PlanningService } from '../../service/planning.service';
import { PlanningEspace } from '../../model/planningEspace.model';
import { ClientService } from '../../service/client.service';
import { Planning }  from '../../model/planning.model';

import { UtilisateurService } from '../../service/utilisateur.service';
import { Utilisateur } from '../../model/utilisateur.model';
import {PlanningMultiple} from '../../model/planningMultiple.model';

@Component({
  selector: 'app-planningespace',
  templateUrl: './planningespace.component.html',
  styleUrls: ['./planningespace.component.scss']
})
export class PlanningespaceComponent implements OnInit {

  id: string;
  espace: Espace;
  titre: string;
  currentUser: Utilisateur;
  planningEspaces: PlanningEspace[];
  dateDuJour: Date = new Date();
  maDate: Date;
  nbjourShow: number = 15;
  nbjourParcours: number = 0;

  disableNext: boolean = false;
  disableprev: boolean = true;

  myFilter = (d: Date): boolean => {
    const day = d.getDay();

    const dayDeb = new Date();
    const dayFin = new Date();

    dayFin.setDate(dayFin.getDate()+14);
    dayDeb.setDate(dayDeb.getDate() -1);

    //console.log(dayDeb);

    // Prevent Saturday and Sunday from being selected.
    return d >= dayDeb ;
  }
  datePipe: DatePipe;

  autoHide = 3000;
  addExtraClass = false;
  actionButtonLabel = 'Retry';
  action = false;


  dialogRef: MatDialogRef<AddClientEspaceComponent>;
  lastCloseResult: string;
  config: MatDialogConfig = {
    disableClose: false,
    width: '400px',
    height: '',
    position: {
      top: '',
      bottom: '',
      left: '',
      right: ''
    }
  };

  constructor(private router: Router,
              private route: ActivatedRoute,
              private espaceService: EspaceService,
              private planningService: PlanningService,
              public dialog: MatDialog,
              public snackBar: MatSnackBar) {

                this.datePipe =  new DatePipe("en-US");
               }

  ngOnInit() {
    this.currentUser = JSON.parse(sessionStorage.getItem('parklife'));
    this.id = this.route.snapshot.params['id'];
    this.espaceService.get(this.id).subscribe(res =>{
      this.espace = res;
      // this.titre =  this.espace.designation;
    });
    this.maDate = new Date();



  }

  selectDate(event: MatDatepickerInputEvent<Date>) {
    //console.log(event.value);

    this.maDate  = new Date(event.value);
    this.dateDuJour = new Date(event.value);

    if (this.espace) {
      this.afficherPlanning(this.datePipe.transform(this.dateDuJour,'yyyy-MM-dd'), this.espace.idespace);
    } else {

    }
  }


  afficherPlanning(date: string, idespace: string) {
    this.planningService.getAll(date, idespace, this.currentUser.idutilisateur).subscribe(res =>{
      this.planningEspaces = res
    });
  }



public reserver(plan: PlanningEspace , index: number) {
     const planningMultiple = new PlanningMultiple();
      planningMultiple.datedebut = plan.datedebut;
      planningMultiple.datefin = plan.datefin;
      planningMultiple.idespace = Number(this.espace.idespace);
      planningMultiple.idutilisateur = Number(this.currentUser.idutilisateur);
      planningMultiple.idclients = [];
      planningMultiple.idclients.push(0);
      planningMultiple.planningstodelete = [];
    

      this.planningService.createMultiple(planningMultiple).subscribe(res => {
        const config = new MatSnackBarConfig();
        if (res === true) {
          config.duration = this.autoHide;
          config.extraClasses = this.addExtraClass ? ['party'] : null;

          this.snackBar.open('Votre planning a été enregistrée avec succès.', this.action && this.actionButtonLabel, config);
        
          this.afficherPlanning(this.datePipe.transform(this.dateDuJour,'yyyy-MM-dd'), this.espace.idespace);

        } else {
          config.duration = this.autoHide;
          config.extraClasses = this.addExtraClass ? ['party'] : null;
          this.snackBar.open(' Il y a une erreur lors de l\'enregistrement de votre planning.', this.action && this.actionButtonLabel, config);
        }

        }, error => {
        const config = new MatSnackBarConfig();
        config.duration = this.autoHide;
        config.extraClasses = this.addExtraClass ? ['party'] : null;
        this.snackBar.open('Une erreur a été rencontrée lors de l\'enregistrement de votre planning.', this.action && this.actionButtonLabel, config);

        });

}


public delete(plan: PlanningEspace , index: number) {
  const planningMultiple = new PlanningMultiple();
      planningMultiple.datedebut = plan.datedebut;
      planningMultiple.datefin = plan.datefin;
      planningMultiple.idespace = Number(this.espace.idespace);
      planningMultiple.idutilisateur = Number(this.currentUser.idutilisateur);
      planningMultiple.idclients = [];
      planningMultiple.idclients.push(0);
      planningMultiple.planningstodelete = [];
   
   this.planningService.removePlanning(planningMultiple).subscribe(res => {
      const config = new MatSnackBarConfig();
      config.duration = this.autoHide;
      config.extraClasses = this.addExtraClass ? ['party'] : null;
      this.snackBar.open('Votre planning a été enregistrée avec succès.', this.action && this.actionButtonLabel, config);
      this.afficherPlanning(this.datePipe.transform(this.dateDuJour,'yyyy-MM-dd'), this.espace.idespace);
    }, error => {
    const config = new MatSnackBarConfig();
    config.duration = this.autoHide;
    config.extraClasses = this.addExtraClass ? ['party'] : null;
    this.snackBar.open('Une erreur a été rencontrée lors de l\'enregistrement de votre planning.', this.action && this.actionButtonLabel, config);

    });


   

}

    addclient(plan: PlanningEspace, index: number) {
      this.dialogRef = this.dialog.open(AddClientEspaceComponent, this.config);
      this.dialogRef.componentInstance.plan = plan;
      this.dialogRef.componentInstance.espace = this.espace;
      //this.dialogRef.componentInstance.clients = this.clients;

      this.dialogRef.afterClosed().subscribe(result => {

        this.afficherPlanning(this.datePipe.transform(this.dateDuJour,'yyyy-MM-dd'), this.espace.idespace);
        this.lastCloseResult = result;
        this.dialogRef = null;

      });


  }

}


@Component({
  selector: 'app-addClientEspace-dialog',
  template: `

  <h5 class="mt-0">Sélectionner un client</h5>


  <form>

        <mat-select [(ngModel)]="selectedValue" name="clt">

          <mat-option *ngFor="let client of clients" [value]="client.idclient">
            {{client.prenom}} {{client.nom}}
          </mat-option>

        </mat-select>

  </form>

  <div class="text-center">
     <button class="mat-grey-400" mat-raised-button  (click)="valider()" >Valider</button>
  </div>`



})
export class AddClientEspaceComponent implements OnInit  {


  @Input()
  plan: PlanningEspace;

  @Input()
  espace: Espace;


  clients: Client[];
  selectedValue: string;


  autoHide = 3000;
  addExtraClass = false;
  actionButtonLabel = 'Retry';
  action = false;

  constructor(public dialogRef: MatDialogRef <AddClientEspaceComponent>,
              private clientService: ClientService,
              private planningService: PlanningService,
              private utilisateurService: UtilisateurService,
              public snackBar: MatSnackBar) {

  }

  ngOnInit() {

      this.clientService.getAll().subscribe(res =>{
        this.clients = res;
      });

  }

  valider() {
    //console.log(row.selectedOptions.selected);


    this.utilisateurService.getByClient(this.selectedValue).subscribe(user =>{

      const planningMultiple = new PlanningMultiple();
      planningMultiple.datedebut = this.plan.datedebut;
      planningMultiple.datefin = this.plan.datefin;
      planningMultiple.idespace = Number(this.espace.idespace);
      planningMultiple.idutilisateur = Number(user.idutilisateur);
      planningMultiple.idclients.push(user.idclient);
      planningMultiple.planningstodelete = [];
      if(this.plan.reserve == true){
         planningMultiple.planningstodelete.push(this.plan.idplanning);
      }

      this.planningService.createMultiple(planningMultiple).subscribe(res => {
        const config = new MatSnackBarConfig();
        if (res === true) {
          config.duration = this.autoHide;
          config.extraClasses = this.addExtraClass ? ['party'] : null;
          this.snackBar.open('Votre planning a été enregistrée avec succès.', this.action && this.actionButtonLabel, config);

        } else {
          config.duration = this.autoHide;
          config.extraClasses = this.addExtraClass ? ['party'] : null;
          this.snackBar.open(' Il y a une erreur lors de l\'enregistrement de votre planning.', this.action && this.actionButtonLabel, config);
        }

        }, error => {
        const config = new MatSnackBarConfig();
        config.duration = this.autoHide;
        config.extraClasses = this.addExtraClass ? ['party'] : null;
        this.snackBar.open('Une erreur a été rencontrée lors de l\'enregistrement de votre planning.', this.action && this.actionButtonLabel, config);

        });


    })

     this.dialogRef.close();



  }

}




// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/administration/planningespace/planningespace.component.ts